module.exports = __webpack_public_path__ + "static/media/youtube-popup-pc.d0b62647.jpg";